<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import http from '@/utils/http';
@Options({
  props: {
    phone: String
  },
  data () {
    return {
      get_code_hinder: '获取验证码',
      waiting_time: 61,
      disabled: false
    }
  },
  methods: {
    async getCodeClick () {
      if (this.phone.length ==11) {
        const params = {
          phone: this.phone,
        }
        // 调用获取短信验证码接口
        // const data =  sendMessage(params)
        // console.log(data);
        // sendMessage(params).then(res => {
        //   res = res.data
        //   if (res.status == 200) {
        //     this.$message({
        //       message: '验证码已发送，请稍候...',
        //       type: 'success',
        //       center: true
        //     })
        //   }
        // })

        await http.post('/sendMessage', { mobile: this.phone })
          .then(response => {
            this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            })
          })
          .catch(error => {
            this.$message({
              message: error.response.data.msg,
              type: 'error',
              center: true,
              offset: window.screen.height / 2
            })
          })
        // 因为下面用到了定时器，需要保存this指向
        this.waiting_time--
        this.disabled = true
        this.get_code_hinder = `${this.waiting_time}s`

        const timer = setInterval(() => {
          if (this.waiting_time > 1) {
            this.waiting_time--
            this.get_code_hinder = `${this.waiting_time}s`
          } else {
            clearInterval(timer)
            this.get_code_hinder = '获取验证码'
            this.disabled = false
            this.waiting_time = 61
          }
        }, 1000)
      } else {
        this.disabled = false
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }
    }
  }
})
export default class CodeView extends Vue {
  phone!: string
}
</script>

<template>
  <el-button :disabled="disabled" class="el_get_code" @click="getCodeClick">{{ get_code_hinder }}</el-button>
</template>

<style scoped lang="scss">
.el_get_code {
  width: 20%;
  height: 70px;
  font-size: 16px;
  margin-top: 30px;
  background-color: #42b983;
  color: #ffffff;
  text-align: center;
  line-height: 70px;
  border-radius: 0 30px 30px 0px;
}



</style>
